var moduleMap = {
	"./CMS": () => {
		return Promise.all([__webpack_require__.e("vendors-_yarn___virtual___ant-design-icons-virtual-237611dc43_2_root_yarn_berry_cache_ant-des-e1ade0"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_CMS_tsx-root_yarn_berry_cache_moment-npm-2_30_1-1c51a5c631-10c0_zip_node_modules_moment_l-659d87")]).then(() => (() => ((__webpack_require__(/*! ./src/CMS */ "./src/CMS.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});